<template>
  <layout-component>
    <div class="banner banner-book noise">
      <div class="container">
          <h1 class="left-bullet" v-html="$t('title-banner')"></h1>
      </div>
    </div>
    <div class="container-full container-white container-booking">
      <div class="container">
        <div class="row filter-book" v-if="$store.settings.bookings_disabled">
          <div class="col-12">
            <p class="h4-style bottom-cut mt-2">{{'bookings-closed'|t}}</p>
          </div>
        </div>
        <div v-else class="row filter-book">
          <!-- <div class="col-12 col-lg-3">
            <p class="title">{{'filter-title-01'|t}}</p>
            <b-form-group>
              <b-form-radio-group id="what" v-model="what" name="what">
                <b-form-radio value="rehearse" @click.native.prevent="whatClick('rehearse')">{{'rehearse'|t}}</b-form-radio>
                <b-form-radio value="record" @click.native.prevent="whatClick('record')">{{'record'|t}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div> -->

          <div class="col-12 col-lg-3">
            <p class="title">{{'filter-title-02'|t}}</p>
            <datepicker v-model="when" @input="filterRooms()" monday-first :disabled-dates="disabledDates" :placeholder="placeholder" :format="format" :open-date="datepickerOpenDate"></datepicker>
          </div>

          <div class="col-6 col-lg-3">
            <p class="title">{{'filter-title-03'|t}}</p>

            <div class="select-wrapper">
              <b-form-select v-model="from" ref="fromSelect" @input="filterRooms()">
                <option v-for="(hour, index) in fromSlots" v-if="isValidFromHour(hour)" :value="hour.value" :key="index">{{hour.text}}</option>
              </b-form-select>
            </div>

          </div>

          <div class="col-6 col-lg-3">
            <p class="title">{{'filter-title-04'|t}}</p>
            <div class="select-wrapper">
              <b-form-select v-model="to" ref="toSelect" @input="filterRooms()">
                <option v-for="(hour, index) in toSlots" v-if="isValidHour(hour)" :value="hour.value" :key="index">{{hour.text}}</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <p class="title">{{'filter-title-05'|t}}</p>
            <div class="select-wrapper">
              <b-form-select v-model="howmany" :options="howmanySelect" @input="filterRooms()" />
            </div>
          </div>
          <div class="col-12 mt-1" v-if="$auth.check(2)">
            <p class="title">Admin comment</p>
            <b-form-input v-model="adminComment" placeholder="e.g. Customer Name"></b-form-input>
          </div>
        </div>

        
      </div>

      <div class="container pt-2 pb-3 pt-lg-4 pb-lg-5" v-if="! periodOpen">
        <div class="row">
          <div class="col-12">
            <p class="h4-style bottom-cut mt-2">{{'period-closed'|t}}</p>
          </div>
        </div>
      </div>


      <div class="container pt-2 pb-3 pt-lg-4 pb-lg-5" v-if="periodOpen">
        <div class="row">
            <div class="col-md-12">
              <b-list-group class="rooms-list">
                <div v-for="(room,index) in $store.rooms.content" :key="'room-' + index">

                    <b-list-group-item class="room" v-if="!room.hide">
                      <div class="room-wrapper">
                        <div class="room-name-wrapper">
                           <img :src="$store.rooms.content[room.id-1].images[0]" :alt="`room ${room.id}`">
                           <div class="bg"></div>
                           <span class="name">{{room.name}}</span>
                        </div>
                        <div class="room-size-wrapper">
                          <p>
                            <span class="area">{{room.area}} m²</span>
                            <span class="capacity">max. {{room.capacity}} {{'pers'|t}}</span>
                          </p>
                          <p class="mb-0">{{room.gear | truncate(95) }}</p>
                        </div>
                        <div class="room-price-wrapper">
                          <template v-if="from && to">
                            <template v-if="from==10 && to==22">
                              <div class="hourly"><span>{{room.daily_rate}}€</span></div>
                              <div class="daily"><span>{{formatPrice(room.daily_rate/12)}}€</span>/h</div>
                            </template>
                            <template v-else>
                              <div class="hourly"><span>{{room.hourly_rate*(to-from)}}€</span></div>
                              <div class="daily"><span>{{formatPrice(room.hourly_rate)}}€</span>/h</div>
                            </template>
                          </template>
                          <template v-else>
                            <div class="hourly"><span>{{room.hourly_rate}}€</span>/h</div>
                            <div class="daily"><span>{{room.daily_rate}}€</span>/{{'day'|t}}</div>
                          </template>
                        </div>
                        <div class="room-buttons-wrapper">
                          <b-button v-if="!$store.settings.bookings_disabled" v-b-tooltip="tooltipOptions" variant="outline-secondary" @click="book(room)" :class="{'cant-book':! allowBooking()}"><span>{{'btn-book'|t}}</span></b-button>
                          <b-button variant="outline-secondary" v-b-modal="'r'+room.id" class="btn-link">{{'btn-view-more'|t}}</b-button>
                        </div>
                      </div>
                    </b-list-group-item>

                    <!-- Modal -->
                    <b-modal :id="'r'+room.id" ref="roomModal" size="lg" scrollable centered hide-footer hide-header @shown="modalopen">
                      <div class="row">
                        <div class="col-lg-7">
                          <swiper :options="swiperOption" :ref="'swiper'+room.id">
                            <swiper-slide v-for="image in room.images" :key="image" :style="'background-image:url(\''+image+'\')'"></swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                            <div class="swiper-button-prev" slot="button-prev"></div>
                            <div class="swiper-button-next" slot="button-next"></div>
                          </swiper>
                        </div>
                        <div class="col-lg-5 content-right">
                          <button type="button" aria-label="Close" class="close" @click="hideModal()"><b-img src="/storage/img/icon/icon-cross-close-modal.svg" class="cross-close-modal" width="16" height="16" /></button>



                          <div class="infos">
                            <div class="header align-items-center justify-content-between" :class="{ 'header-fr': $i18n.locale == 'fr' }">
                              <div class="h1-style">{{ room.name }}</div>
                              <div class="header-infos">
                                <p v-if="room.daylight == '1'">{{'natural-light'|t}}</p>
                                <p v-if="room.daylight == '0'">{{'no-natural-light'|t}}</p>
                                <p>{{'floor'|t}} {{ room.floor }}</p>
                              </div>

                            </div>

                            <div class="row description infos-section">
                              <div class="col-md-12">
                                <h3 class="left-bullet">{{'description'|t}}</h3>
                              </div>
                              <div class="col-md-6 info" v-if="room.pa">
                                <p class="title">{{'pa'|t}}</p>
                                <p v-html="room.pa"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.layout">
                                <p class="title">{{'uponrequest'|t}}</p>
                                <p v-html="room.layout"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.mixer">
                                <p class="title">{{'mixer'|t}}</p>
                                <p v-html="room.mixer"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.guitar_amp">
                                <p class="title">{{'guitare-amplifier'|t}}</p>
                                <p v-html="room.guitar_amp"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.bass_amp">
                                <p class="title">{{'bass-amplifier'|t}}</p>
                                <p v-html="room.bass_amp"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.drums">
                                <p class="title">{{'drums'|t}}</p>
                                <p v-html="room.drums"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.dj">
                                <p class="title">{{'dj'|t}}</p>
                                <p v-html="room.dj"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.music_prod">
                                <p class="title">{{'music-prod'|t}}</p>
                                <p v-html="room.music_prod"></p>
                              </div>
                            </div>

                            <div class="row room-size infos-section">
                              <div class="col-md-12">
                                <h3 class="left-bullet">{{'room-size'|t}}</h3>
                              </div>

                              <div class="col-md-12 info">
                                <img class="img-fluid"  v-if="room.image_room_size" :src="room.image_room_size" />
                              </div>

                              <div class="col-6 col-md-4 info" v-if="room.length">
                                <p>{{'length'|t}}</p>
                                <p v-html="room.length + 'cm'" class="title"></p>
                              </div>

                              <div class="col-6 col-md-4 info" v-if="room.width">
                                <p>{{'width'|t}}</p>
                                <p v-html="room.width +  'cm'" class="title"></p>
                              </div>

                              <div class="col-6 col-md-4 info" v-if="room.height">
                                <p>{{'height'|t}}</p>
                                <p v-html="room.height +  'cm'" class="title"></p>
                              </div>

                              <!-- <div class="col-md-12 info">
                                <a :href="'/storage/pdf/room-'+ room.name +'-plan-sonotron.pdf'" target="_blank" class="btn-link">{{'download-plan'|t}}</a>


                              </div> -->

                            </div>

                            <div class="row room-need-more infos-section">
                              <div class="col-md-12">
                                <h3 class="left-bullet">{{'need-more-title'|t}}</h3>
                              </div>
                              <div class="col-md-12">
                                <p v-html="$t('need-more-text')"></p>
                              </div>
                            </div>


                            <div class="row room-rules infos-section">
                              <div class="col-md-12">
                                <h3 class="left-bullet">{{'rules-title'|t}}</h3>
                              </div>
                              <div class="col-md-12">
                                <p v-html="$t('rules-text')"></p>
                              </div>
                            </div>
                          </div>

                          <div class="bottom-infos d-flex align-items-center">
                            <b-button v-b-tooltip="tooltipOptions" variant="outline-secondary" @click="book(room)" :class="{'cant-book': ! allowBooking()}" class="order-lg-2"><span>{{'btn-book'|t}}</span></b-button>
                            <div class="room-price-wrapper mr-lg-auto order-lg-1">
                              <div class="hourly"><span>{{room.hourly_rate}}€</span>/h</div>
                              <div class="daily"><span>{{room.daily_rate}}€</span>/{{'day'|t}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-modal>
                </div>
              </b-list-group>

              <p class="small small-bottom-text" v-html="$t('room-bottom-text')"></p>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row d-flex align-items-center pb-4 pb-md-5">
            <div class="col-md-5">
              <div class="noise">
                <b-img src="/storage/img/pic/pic-book-01.webp" alt="Guitarist singing" />
              </div>
            </div>
            <div class="col-md-4 offset-md-1 mt-15">
                <p class="h4-style bottom-cut br-title" v-html="$t('title-02')"></p>
                <div v-html="$t('text-02')"></div>
            </div>
        </div>
      </div>
    </div>

    <div class="banner-prefooter banner-prefooter-book noise">
        <div class="container">
            <p class="h2-style">
                <span v-html="$t('big-cta-01-text')"></span>
                <router-link class='btn-link btn-link-big left-bullet' to='/discover' exact v-html="$t('big-cta-01')"></router-link>
            </p>
        </div>
    </div>
	</layout-component>
</template>

<script>
import Datepicker from "vuejs-datepicker"
  export default {
    components: {
      Datepicker
    },
    data() {
      return {
        bookingClosed: false, //Set to true to disable bookings (COVID-19)
        periodOpen: true,
        placeholder: "--",
        format: "dd/MM/yyyy",
        cutoffDate: new Date('2020-07-07'),
        what:null,
        when:null,
        from:null,
        to:null,
        howmany:null,
        adminComment: null,
        canBook:false,
        isWeekendToday:null,
        datepickerOpenDate: moment('2020-06-01').isAfter() ? moment('2020-06-01').toDate() : new Date(),
        fromSlots: [
          {value: null, text: '--'},
          {value:10, text:"10:00"},
          {value:12, text:"12:00"},
          {value:14, text:"14:00"},
          {value:16, text:"16:00"},
          {value:18, text:"18:00"},
          {value:20, text:"20:00"}
        ],
        toSlots: [
          {value: null, text: '--'},
          {value:12, text:"12:00"},
          {value:14, text:"14:00"},
          {value:16, text:"16:00"},
          {value:18, text:"18:00"},
          {value:20, text:"20:00"},
          {value:22, text:"22:00"}
        ],
        howmanySelect: [
          {value: null, text: '--'},
          {value:1, text:"1 max."},
          {value:2, text:"2 max."},
          {value:3, text:"3 max."},
          {value:4, text:"4 max."},
          {value:6, text:"6 max."},
          {value:10, text:"10 max."}
        ],
        swiperOption: {
          slidesPerView: 1,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        disabledDates: {
          dates: [
            new Date(2020, 5, 28),
            new Date(2020, 6, 5 )
          ],
          to: moment("2020-06-02").isAfter() ? moment("2020-06-01").toDate() : moment().subtract(1, 'days').toDate(),
          days: [1], // disable Mondays (0=Sunday, 1=Monday, 2=Tuesday, etc.)
          //disable limit date if admin
          from: this.$auth.check(2) ? null : moment().add(2, 'months').toDate()
        }
      }
    },
    methods: {
      book(room) {
        if(this.$auth.check()) {
          if(this.canBook && this.periodOpen) {
            Vue.axios.post('/cart', {
              room_id: room.id,
              date: moment(this.when).format('YYYY-MM-DD'),
              from: this.from,
              to: this.to,
              comment: this.adminComment,
            }).then(({data}) => {
              this.hideModal()
              this.filterRooms()
              this.$store.setCart(data)
              this.$store.cartDropdown.show()
            })
          }
        } else {
          this.$router.push('login')
        }
      },
      allowBooking() {
        if (this.canBook && this.periodOpen) {
          // Check if booking date/time is in the past
          if (this.when && this.from && this.to) {
            const selectedDate = moment(this.when);
            const today = moment();
            
            // If selected date is before today, don't allow booking
            if (selectedDate.isBefore(today, 'day')) {
              return false;
            }
            
            // If selected date is today, check if the time slot has finished
            if (selectedDate.isSame(today, 'day')) {
              const currentHour = moment().hour();
              // Check if the end time has passed (not the start time)
              if (this.to <= currentHour) {
                return false;
              }
            }
          }
          return true
        }

        return false;
      },
      modalopen() {
        Vue.nextTick(() => window.dispatchEvent(new Event('resize')))
        OverlayScrollbars(document.querySelectorAll(".infos"), {
          overflowBehavior : {
        		x : "visible-hidden",
        		y : "scroll"
        	}
        });
      },
      hideModal() {
        this.$refs.roomModal.forEach(modal => {
          modal.hide()
        })
      },
      whatClick(activity) {
        if(activity == this.what) {
          this.what = null
        } else {
          this.what = activity
        }
        this.filterRooms()
      },
      tooltipOptions() {
        if(this.$auth.check()) {
          if(this.canBook) {
            if(this.periodOpen) {
              // Check if booking date is in the past
              if (this.when && moment(this.when).isBefore(moment(), 'day')) {
                return this.$t('tooltip-time-passed');
              }
              
              // Check if booking time slot has finished (for same day bookings)
              if (this.when && this.from && this.to && moment(this.when).isSame(moment(), 'day')) {
                const currentHour = moment().hour();
                // Check if the end time has passed (not the start time)
                if (this.to <= currentHour) {
                  return this.$t('tooltip-time-passed');
                }
              }
              return '';
            } else {
              return this.$t('tooltip-change-when')
            }
          } 
          else {
            return this.$t('tooltip-choose-when')
          }
        } else {
          return this.$t('tooltip-login')
        }
      },
      formatPrice(price) {
        if (typeof price === 'undefined') {
          return 0;
        }

        return price.toLocaleString();
      },
      filterRooms() {
        // Calculate end time
        if (this.from === 20) {
          this.to = 22;
        }
        // Set isWeekend
        if (this.when) {
          this.isWeekendToday = moment().isSame(this.when, 'day') && (moment(this.when).day() === 0 || moment(this.when).day() === 6);
        }
        if (this.when && this.from && this.to) {
          if (this.to <= this.from) {
            this.to = this.from + 2;
          }
          Vue.axios.post('/room/filter', {
            when: moment(this.when).format('YYYY-MM-DD'),
            from: this.from,
            to: this.to
          }).then(({ data }) => {
            this.$store.rooms.content.forEach(room => {
              room.hide = false;
              if (this.what && this.what === "record" && room.type === "room") {
                room.hide = true;
              }
              if (room.capacity < this.howmany) {
                room.hide = true;
              }
              if (data.indexOf(room.id) > -1) {
                room.hide = true;
              }
            });
            this.$forceUpdate();
          });
          Vue.axios.post('/room/periods', {
            when: moment(this.when).format('YYYY-MM-DD'),
            from: this.from,
            to: this.to
          }).then(({ data }) => {
            this.periodOpen = data;
          });
          this.canBook = this.$auth.check();
        } else {
          this.canBook = false;
          this.$forceUpdate();
          this.$store.rooms.content.forEach(room => {
            room.hide = false;
            if (this.what && this.what === "record" && room.type === "room") {
              room.hide = true;
            }
            if (room.capacity < this.howmany) {
              room.hide = true;
            }
          });
        }
      },
      isValidHour(hour) {
        if (this.isWeekendToday && hour.value >= 14) return true;
        if (this.when < this.cutoffDate && hour.value >= 14 && hour.value <= 20 && (!this.from || hour.value > this.from || !hour.value)) return true;
        if (this.when > this.cutoffDate && (!this.from || hour.value > this.from || !hour.value)) return true;
        return false;
      },
      isValidFromHour(hour) {
        if (this.isWeekendToday && hour.value >= 12) return true;
        if (this.when < this.cutoffDate && hour.value >= 12 && hour.value <= 18) return true;
        if (this.when > this.cutoffDate || !hour.value) return true;
        return false;
      }
    },
    mounted() {
      $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
      if ( $( '.banner-prefooter .title-anim-wrapper' ).is( ':in-viewport' ) ) {
        $('.banner-prefooter').addClass('in-viewport');
      }

      $('.noise').each(function() {
        if ($(this).is( ':in-viewport' ) ) {
          $(this).addClass('in-viewport');
        } else {
          $(this).removeClass('in-viewport');
        }
      });
    }
  }
</script>

<i18n>
    {
      "en": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Book a room</span></span>",
        "filter-title-01": "What do you need?",
        "rehearse": "Rehearse",
        "record": "Record",
        "filter-title-02": "When?",
        "filter-title-03": "From",
        "filter-title-04": "To",
        "filter-title-05": "How many people?",
        "pers": "pers.",
        "day": "day",
        "btn-book": "Book",
        "btn-view-more": "View more",
        "natural-light": "Natural light",
        "no-natural-light": "No natural light",
        "floor": "Floor",
        "description": "Description",
        "pa": "Piano",
        "uponrequest": "Upon request",
        "mixer": "Mixer & PA",
        "guitare-amplifier": "Guitar amplifier(s)",
        "bass-amplifier": "Bass amplifier(s)",
        "drums": "Drums",
        "dj": "DJ Equipment",
        "music-prod": "Music Production",
        "room-size": "Room size",
        "length": "Length",
        "width": "Width",
        "height": "Height",
        "download-plan": "Download the plan (.pdf)",
        "need-more-title": "Need more?",
        "need-more-text": "All rehearsal rooms are equipped &lowast; with basic instruments such as drums, amplifiers, PA systems, etc. Customers are free to bring and use their own equipment in the room for the time of their rehearsal<br />Microphones and cables are available free of charge upon signature of a dedicated form.<br />The Sonotron does not provide computers and related accessories.<br /><br />&lowast; Equipment in the studio may vary occasionnally due to maintenance or repairs.",
        "rules-title": "Rules",
        "rules-text": "All our rooms and studios are non-smoking area. No food or drinks (beside those contained in bottles with re-sealable lids) are allowed inside the rooms; please consume them in the lounge area. Take care of the equipment as if it was yours. Cancellation is possible up to 24 hours before the date of the session (refund of 50%). Please read the full <a href='/terms-of-use' target='_blank'>Terms of use</a>.",
        "title-02": "Silence? You got it. <br />Noise? Go for it.",
        "text-02": "<p>Each space comes stocked with a drum set, mixer, PA & amplifiers. Just plug in & play.</p><ul class='bullet-list'><li>High-end equipment</li><li>Ramps & easy loading</li><li>Lounge space</li><li>Events & networking</li></ul>",
        "big-cta-01-text": "<span class='title-anim-wrapper'><span class='title-anim td'>Luxembourg’s</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>first music studio</span></span> <span class='title-anim-wrapper'><span class='title-anim td-3'>for the masses.</span></span>",
        "big-cta-01": "<span class='title-anim-wrapper'><span class='title-anim td-4'>The Sonotron story</span></span>",
        "tooltip-choose-when": "Please select a date and time slot",
        "tooltip-change-when": "Please select an other time slot",
        "tooltip-time-passed": "Selected time slot has already passed",
        "tooltip-login": "Please login",
        "room-bottom-text": "Rooms can be booked up to 8 weeks in advance.<br />For music creation residency, tour training or even album development, please contact us by email: <a class='font-weight-bold' href='mailto:info@sonotron.lu'>info@sonotron.lu</a>",
        "bookings-closed": "We are temporarily closed. We apologize. Stay safe.",
        "period-closed": "No rooms are available at the selected date and time. Please modify your search."
      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Reserver une salle</span></span>",
        "filter-title-01": "Que voulez-vous ?",
        "rehearse": "Répéter",
        "record": "Enregistrer",
        "filter-title-02": "Quand ?",
        "filter-title-03": "De",
        "filter-title-04": "À",
        "filter-title-05": "Combien de personnes ?",
        "pers": "pers.",
        "day": "jour",
        "btn-book": "Réserver",
        "btn-view-more": "Plus d’infos",
        "natural-light": "Lumiere naturelle",
        "no-natural-light": "Pas de lumière naturelle",
        "floor": "Etage",
        "description": "Description",
        "pa": "Piano",
        "uponrequest": "Sur demande",
        "mixer": "Sonorisation",
        "guitare-amplifier": "Amplificateur(s) de guitare",
        "bass-amplifier": "Amplificateur(s) de basse",
        "drums": "Batterie",
        "dj": "Equipement DJ",
        "music-prod": "Production Musicale",
        "room-size": "Dimensions",
        "length": "Longueur",
        "width": "Largeur",
        "height": "Hauteur",
        "download-plan": "Télécharger le plan (.pdf)",
        "need-more-title": "Quoi d’autre ?",
        "need-more-text": "Toutes les salles de répétition sont équipées &lowast; d’instruments de base tels que batterie, amplificateurs, sonorisations, etc. Il est possible d’apporter vous-même tout autre matériel/instrument dont vous auriez besoin pour vos répétitions.<br />Des micros avec câble vous seront mis à disposition gratuitement contre signature d’une fiche de mise à disposition à la réception du Sonotron.<br />Le Sonotron ne fournit pas d’ordinateurs et d’accessoires associés.<br /><br />&lowast; L'équipement du studio peut varier occasionnellement pour des raisons d'entretien ou de réparation.",
        "rules-title": "Reglement",
        "rules-text": "Toutes nos salles ainsi que notre studio sont non-fumeur. Il est interdit d’y introduire à manger ou à boire (sauf dans des contenants avec capuchon refermable). L’espace lounge est prévu à cet effet.<br />Prenez soin de l’équipement comme si c’était le vôtre. Vous pouvez annuler votre réservation jusqu’à 24 heures avant la date de la séance (remboursement à hauteur de 50 %). Veuillez lire l’intégralité du règlement dans nos <a href='/terms-of-use' target='_blank'>conditions d’utilisation</a>.",
        "title-02": "Du silence ? C’est promis. <br />Du bruit ? Allez-y.",
        "text-02": "<p>Chaque espace dispose d’une batterie, d’amplificateurs, PA et d’une table de mixage. Vous n’avez plus qu’à vous installer et vous lancer.</p><ul class='bullet-list'><li>Équipement haut de gamme</li><li>Rampes et chargement facile</li><li>Espace lounge</li><li>Évènements et réseautage</li></ul>",
        "big-cta-01-text": "<span class='title-anim-wrapper'><span class='title-anim td'>Le premier studio musical</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>pour tous</span></span> <span class='title-anim-wrapper'><span class='title-anim td-3'>au Luxembourg</span></span>",
        "big-cta-01": "<span class='title-anim-wrapper'><span class='title-anim td-4'>L’histoire du Sonotron</span></span>",
        "tooltip-choose-when": "Veuillez choisir une date et un créneau horaire",
        "tooltip-change-when": "Veuillez choisir un autre créneau horaire",
        "tooltip-time-passed": "Le créneau horaire sélectionné est déjà passé",
        "tooltip-login": "Veuillez vous connecter",
        "room-bottom-text": "Les salles peuvent être réservées sur une période de 8 semaines maximum.<br />Pour des résidences de création musicale, de préparation d’une tournée, voire d’un développement d’album, contactez-nous par email : <a class='font-weight-bold' href='mailto:info@sonotron.lu'>info@sonotron.lu</a>",
        "bookings-closed": "Nous sommes temporairement fermés. Veuillez nous excuser. Prenez soin de vous.",
        "period-closed": "Aucune salle n’est disponible à la date et heures sélectionnées. Veuillez modifier votre recherche."
      }
    }
  </i18n>